import React, { Component } from 'react';
import { translate } from "react-i18next";
import CtaBlock from "../../components/cta-block";
import TitleSection from "../../components/title-section";
import { selectors as cmsSelectors } from 'shared/redux/cms';
import { connect } from 'react-redux';
import Loader from '../../components/loader';
import './index.scss';
import { NavBarStyles } from 'components/navBar';

class Privacy extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    this.props.navBar.setStyle(NavBarStyles.dark);
  }
  componentWillUnmount() {
    this.props.navBar.setStyle();
  }
  renderItem(item) {
    return (
      <li key={item.text} className={!item.level && 'numbered-list-title'}>
        { item.text }
        { item.items && !!item.items.length &&
        <ol className={item.level === 3 ? 'lettered-list' : 'numbered-list'}>
          { item.items.map(item => this.renderItem(item)) }
        </ol>
        }
      </li>
    );
  }
  render() {
    const { t, content } = this.props;

    return (
      <main>
        {content && Object.keys(content).length > 0 ?
          <div>
            <section id="privacy">
              <TitleSection title={content.title} />
              {content.description &&
                <div className="description">
                  {content.description}
                </div>
              }
              <div className="row typography collapse">
                <div className="large-11 small-centered columns">
                  <div className="anim" data-anim="fadeIn">
                    { this.renderItem({ items: content.content }) }
                  </div>
                </div>
              </div>
            </section>
            <CtaBlock />
          </div> :
          <div className="privacy-loader">
            <Loader />
          </div>
        }
      </main>
    );
  }
};

const {
  getPrivacy
} = cmsSelectors;

const mapStateToProps = state => ({
  content: getPrivacy(state)
});

export default translate('translations')(connect(
  mapStateToProps
)(Privacy));
